import type { FC } from 'react';
import clsx from 'clsx';

import { useCurrentUserStore } from 'store/currentUser';

import User from 'components/Pages/Call/User';

import { useAllUserList } from 'hooks/useAllUserList';

import { useMainScreenPartContext } from '../../Screen/MainScreenPartContext';
import styles from './styles.module.scss';

const List: FC = () => {
    const { list } = useAllUserList();
    const { activeUser } = useMainScreenPartContext();
    const { currentUser } = useCurrentUserStore();

    return (
        <ul className={clsx(styles.wrapper, 'user-list')}>
            {list.map((user, index) => {
                // показываем видео пользователя в пиктограмме если:
                // - пользователь не является активным пользователем
                // - пользователь является активным пользователем и демонстрирует экран
                const renderVideo = (() => {
                    const isNotActiveUser = activeUser?.id !== user.id;
                    const isActiveUserAndSharing = activeUser?.id === user.id && !!activeUser.isSharing;

                    return isNotActiveUser || isActiveUserAndSharing;
                })();

                return (
                    <li key={`${user.id}-${index}`}>
                        <User {...user} isCurrentUser={currentUser?.id === user.id} renderVideo={renderVideo} />
                    </li>
                );
            })}
        </ul>
    );
};

export default List;
